
define('template!pimProductAttributeValueTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="row">\n    <div class="col-xs-1 onOff">\n        <div class="col">\n            <input type="checkbox" class="cbx" ' +
((__t = ( activated?'checked':'' )) == null ? '' : __t) +
' />\n        </div>\n    </div>\n    <div class="col-xs-11">\n        <div class="code">\n            ' +
((__t = ( code )) == null ? '' : __t) +
'\n        </div>\n    </div>   \n</div>    \n';

}
return __p
};});

